<template>
    <div class="pay-content">
        <el-card class="box-card">
            <div class="table-box">
                <div class="card-title">需求标题:</div>
                <el-input v-model="header.requireTitle" clearable class="handle-input" placeholder="请输入需求标题"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">发布时间:</div>
                <el-date-picker
                    v-model="header.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <el-button type="primary" @click="getSearchList">查询</el-button>
        </el-card>
        <el-card class="box-card mt20">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="requireTitle" label="资源需求标题"></el-table-column>
                <el-table-column prop="requireLabel" label="资源需求标签"></el-table-column>
                <el-table-column prop="budget" label="资源预算"></el-table-column>
                <!-- <el-table-column prop="linkName" label="联系人"></el-table-column> -->
                <!-- <el-table-column prop="linkPhone" label="联系电话"></el-table-column> -->
                <el-table-column prop="requireDesc" label="资源需求描述" show-overflow-tooltip></el-table-column>
                <el-table-column prop="monthRent" label="审核状态">
                    <template slot-scope="{row}">
                        <span v-if="row.requireState == 0" style="color:#F56C6C">审核拒绝</span>
                        <span v-if="row.requireState == 1 || row.requireState == 2" style="color:#67C23A">审核通过</span>
                        <span v-if="row.requireState == 3" style="color:#0066ff">待审核</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-link type="primary" class="mr10" @click="getDemandDetail(row)">编辑</el-link>
                        <el-link type="danger" @click="getDemandDel(row)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog title="资源需求详情" :visible.sync="isVisibleDemandView" width="700px" >
            <el-form label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="需求标题">
                            <el-input class="handle-input" v-model="demandData.requireTitle" clearable placeholder="请输入企业名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="需求标签">
                            <el-input class="handle-input" v-model="demandData.requireLabel" clearable placeholder="请输入资源需求标签"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系人">
                            <el-input class="handle-input" v-model="demandData.linkName" clearable placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话">
                            <el-input class="handle-input" v-model="demandData.linkPhone" clearable placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源预算">
                            <el-input class="handle-input" v-model="demandData.budget" clearable placeholder="请输入资源预算"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="需求描述">
                    <el-input type="textarea" v-model="demandData.requireDesc" clearable placeholder="请输入资源需求描述"></el-input>
                </el-form-item>
                <el-form-item label="需求备注">
                    <el-input type="textarea" v-model="demandData.remark" clearable placeholder="请输入资源需求描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="isVisibleDemandView = false">取 消</el-button>
                <el-button type="primary" @click="getSaveData">保 存</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>
import {
    demandMarketUserList,
    demandMarketDetail,
    demandUpdate,
    demandReleaseDel
} from '@/api/index'
export default {
    data() {
        return {
            header:{
                requireTitle:"",//需求标题
                time:"",//发布时间
            },
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
            isVisibleDemandView:false,
            demandId:"",
            demandData:{},
        };
    },

    mounted() {
        this.getDemandList()
    },

    methods: {
        getSearchList(){
            this.query.currentPage = 1;
            this.getDemandList()
        },
        async getDemandList(){
            let param = {
				pageNum:this.query.currentPage,
				pageSize:this.query.pageSize,
				requireTitle:this.header.requireTitle,//需求标题
				startDate:this.header.time[0],//开始时间
				endDate :this.header.time[1],//结束时间
			}
            let res = await demandMarketUserList(param);
            if(res.success){
                this.tableData = res.data.records;
                this.query.total = res.data.total;
            }
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getDemandList()
        },
        async getDemandDetail(row){
            this.demandId = row.id;
            const resData = await demandMarketDetail(row.id);
            console.log(resData);
            this.demandData = {};
            if(resData.success){
                this.demandData = resData.data;
                this.isVisibleDemandView = true;
            }
        },
        getSaveData(){
            let data = {
                rid:this.demandId,
                requireTitle:this.demandData.requireTitle,
                requireDesc:this.demandData.requireDesc,
                requireLabel:this.demandData.requireLabel,
                budget:this.demandData.budget,
                remark:this.demandData.remark,
                linkName:this.demandData.linkName,
                linkPhone:this.demandData.linkPhone,
            }
            demandUpdate(data).then((res)=>{
                console.log(res);
                if(res.data){
                    this.$message.success('更新成功');
                    this.getDemandList();
                    this.isVisibleDemandView = false;
                }else {
                    this.$message.error('更新失败');
                }
            })
        },
        getDemandDel(row){
            this.$confirm(`确认删除 ${row.requireTitle}, 是否继续?`, '提示', {
                showClose:false,
                closeOnClickModal:false,
				closeOnPressEscape:false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const resData = await demandReleaseDel(row.id);
                if(resData.data){
                    this.$message.success('删除成功');
                    this.query.currentPage = 1;
                    this.getDemandList();
                }else{
                    this.$message.error('删除失败');
                }
            }).catch(()=>{
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            })
        }
    },
};
</script>

<style scoped>
.pay-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
    box-sizing: border-box;
	padding:20px 20px;
	background-color: #f9fafb;
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>